import * as ACTIONS from '../actionTypes/cabinListActionTypes';
import { fetchCabins } from '../../services/cruise';
import { fetchLabels } from '../../services/content';
import { urlUtils } from '../../utils/url';
import { getProductsIncluded } from '../../utils/mappers/productsIncluded';
import { logSearch, logEcom } from '../../utils/logUtils/CabinListLogUtils';

const initSuccess = (labels, data) => {
  urlUtils.updateUrlWithSessionId(data.result.serviceCallInformation.sessionId);
  const { general, ...restLabels } = labels;

  return (dispatch) => {
    dispatch({
      type: ACTIONS.INIT_SUCCESS,
      labels: {
        ...restLabels,
        ...general,
        productsIncludedParsed: getProductsIncluded(
          data.result.selectedPackage.packageTag,
          general,
        ),
      },
      cruise: data.result.selectedPackage.cruise,
      hotels: data.result.selectedPackage.hotels,
      transport: data.result.selectedPackage.transport,
      totalDuration: data.result.selectedPackage.totalDuration,
      numberOfHotelNights: data.result.selectedPackage.numberOfHotelNights,
      searchInformation: data.result.searchInformation,
      priceDetails: data.result.selectedPackage.priceBreakDown,
    });
  };
};

const initFail = (labels) => {
  return {
    type: ACTIONS.INIT_FAIL,
    labels,
  };
};

const addMessage = (message) => {
  return {
    type: ACTIONS.ADD_MESSAGE,
    message,
  };
};

const cabinListInitError = () => {
  return (dispatch) => {
    dispatch({
      type: ACTIONS.INIT_FINISHED,
    });
    dispatch(
      addMessage({
        title: 'An error occurred, please redo your search.',
        severity: 'ERROR',
      }),
    );
  };
};

const initFinished = (labels, data) => {
  return (dispatch) => {
    const { selectedPackage, loggingData } = data?.result;
    if (selectedPackage?.cruise?.cabins?.length > 0) {
      dispatch(initSuccess(labels, data));
    } else {
      dispatch(initFail(labels));
    }

    if (data?.translatedMessage) {
      dispatch(addMessage(data.translatedMessage));
    }

    if (loggingData) {
      logSearch(loggingData, selectedPackage?.cruise);
      if (!urlUtils.isChangeCabinPage()) {
        logEcom(selectedPackage);
      }
    }

    dispatch({
      type: ACTIONS.INIT_FINISHED,
    });
  };
};

const getLabels = async (siteSettings) => {
  const labels = await fetchLabels(siteSettings, 'iwCabinList');
  return labels;
};

const getCabins = async (siteSettings, userId) => {
  const result = await fetchCabins(siteSettings, userId);
  return result;
};

export const init = () => {
  return async (dispatch, getState) => {
    const { siteSettings, userId } = getState().common;

    try {
      const [labelsResult, cruiseResult] = await Promise.all([
        getLabels(siteSettings),
        getCabins(siteSettings, userId),
      ]);

      if (cruiseResult.statusCode !== 200) {
        console.log(`Cabin search error: ${cruiseResult.errorMessage}`);
        dispatch(
          addMessage({
            title: labelsResult
              ? labelsResult.iwErrors?.systemError?.heading
              : 'An error occurred, please redo your search.',
            severity: 'ERROR',
          }),
        );
      }

      dispatch(initFinished(labelsResult, cruiseResult));
    } catch (error) {
      console.log(`Unexpected error in cabin list init: ${error}`);
      dispatch(cabinListInitError());
    }
  };
};

export const selectCabin = (cabinKey) => {
  return {
    type: ACTIONS.SELECT_CABIN,
    cabinKey,
  };
};
